/* eslint-disable @typescript-eslint/camelcase */
import { getHubData } from "@/app/infrastructures/misc/Cookies";
import { UpdateDispatchRequestInterface } from "../contracts/DispatchRequest";
import { ConvertObjectCamelToSnakeCase } from "@/app/infrastructures/misc/Utils";

export class UpdateDispatchRequest implements UpdateDispatchRequestInterface {
  private scanNo: string;

  constructor(scanNo: string) {
    this.scanNo = scanNo;
  }

  public toJSON(): string {
    return JSON.stringify({
      scan_no: this.scanNo,
      hub_id: getHubData()?.hubId,
      hub_name: getHubData()?.hubName,
      hub_origin_city: getHubData()?.originCity,
      hub_district_code: getHubData()?.hubDistrictCode
    });
  }
}

export class ProcessUpdateDispatchRequest
  implements UpdateDispatchRequestInterface {
  private dispatchToDriverId?: number;
  private dispatchToDriverName?: string;
  private dispatchToDriverPhone?: string;
  private dispatchToShuttleId?: number;
  private dispatchToShuttleName?: string;
  private dispatchToHubId?: number;
  private dispatchToHubName?: string;
  private dispatchToCityCode?: string;


  constructor(
    dispatchToDriverId?: number,
    dispatchToDriverName?: string, 
    dispatchToDriverPhone?: string, 
    dispatchToShuttleId?: number,
    dispatchToShuttleName?: string, 
    dispatchToHubId?: number, 
    dispatchToHubName?: string, 
    dispatchToCityCode?: string
  ) {
    this.dispatchToDriverId = dispatchToDriverId;
    this.dispatchToDriverName = dispatchToDriverName;
    this.dispatchToDriverPhone = dispatchToDriverPhone;
    this.dispatchToShuttleId = dispatchToShuttleId;
    this.dispatchToShuttleName = dispatchToShuttleName;
    this.dispatchToHubId = dispatchToHubId;
    this.dispatchToHubName = dispatchToHubName;
    this.dispatchToCityCode = dispatchToCityCode;
  }

  public toJSON(): string {
    const payload: any = {
      hubId: getHubData()?.hubId
    }


    if (this.dispatchToDriverId) {
      payload.dispatchToDriverId = this.dispatchToDriverId;
      payload.dispatchToDriverName = this.dispatchToDriverName;
      payload.dispatchToDriverPhone = this.dispatchToDriverPhone;
      payload.dispatchToHubId = this.dispatchToHubId;
      payload.dispatchToHubName = this.dispatchToHubName;
      payload.dispatchToCityCode = this.dispatchToCityCode;
    }

    if (this.dispatchToShuttleId) {
      payload.dispatchToShuttleId = this.dispatchToShuttleId;
      payload.dispatchToShuttleName = this.dispatchToShuttleName;
      payload.dispatchToHubId = this.dispatchToHubId;
      payload.dispatchToHubName = this.dispatchToHubName;
      payload.dispatchToCityCode = this.dispatchToCityCode;
    }

    return JSON.stringify(
      ConvertObjectCamelToSnakeCase(payload)
    );
  }
}
